import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { IncidentTypeModel } from "../models/incident-type.model";
import { IncidentTypeEditModel } from "../models/incident-type-edit.model";
import { BaseStandingDataService } from "../../standing-data/interfaces/base-standing-data.service";
import { IncidentTypeDisplayModel } from "../models/incident-type-display.model";

@Injectable({
    providedIn: "root",
})
export class IncidentTypesService implements BaseStandingDataService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly baseUrl = `${localStorage.getItem("incidentUrl")}/api/incident-types`;

    public getAll(): Observable<IncidentTypeModel[]> {
        return this.httpClient.get<IncidentTypeModel[]>(`${this.baseUrl}/all`);
    }

    public getAllTypesForIncident(incidentId: string): Observable<IncidentTypeModel[]> {
        let url = this.baseUrl;

        if (!!incidentId && incidentId !== "") {
            url = `${this.baseUrl}?incidentId=${incidentId}`;
        }

        return this.httpClient.get<IncidentTypeModel[]>(url);
    }

    public getIncidentType(incidentTypeId: string): Observable<IncidentTypeEditModel> {
        return this.httpClient.get<IncidentTypeEditModel>(`${this.baseUrl}/${incidentTypeId}`);
    }

    public addIncidentType(incidentType: IncidentTypeEditModel): Observable<string> {
        return this.httpClient.post<string>(this.baseUrl, incidentType);
    }

    public editIncidentType(incidentType: IncidentTypeEditModel): Observable<void> {
        return this.httpClient.put<void>(`${this.baseUrl}/${incidentType.id}`, incidentType);
    }

    public deleteIncidentType(incidentTypeId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/${incidentTypeId}`);
    }

    public changeOrder(incidentTypeId: string, order: number): Observable<void> {
        return this.httpClient.patch<void>(`${this.baseUrl}/${incidentTypeId}/order`, order);
    }

    public getSectionsAndCustomFields(
        incidentTypeIds: string[]
    ): Observable<IncidentTypeDisplayModel[]> {
        return this.httpClient.get<IncidentTypeDisplayModel[]>(
            `${this.baseUrl}/custom-fields?ids=${JSON.stringify(incidentTypeIds)}`
        );
    }
}
